<div class="ui-tab w-100 h-100 flex-col gap-16">
  @if (!group()) {
    <div class="w-100 h-100 flex-1">
      <ui-preloader [color]="loaderColor.blue"></ui-preloader>
    </div>
  } @else {
    <div class="flex-row space-between-center person-group-details-toolbar">
      <div class="person-group-details-toolbar-left flex-row start-center gap-8 min-w-0">
        <span class="person-group-details-name">{{ group().name }}</span>
        @if (canRenamePersonGroup()) {
          <ui-button
            type="noBorderDefault"
            iconClass="ui-icon-edit"
            [matTooltip]="'COMMON.EDIT' | translate"
            matTooltipClass="sidebar-tooltip"
            [attr.aria-label]="'PERSON_GROUPS.DETAIL.EDIT_NAME' | translate"
            (click)="editName()"></ui-button>
        }
      </div>
      <div class="person-group-details-toolbar-right flex-row center-center gap-16">
        @if (canEditGroupMembers()) {
          <ui-button
            type="default"
            iconClass="ui-icon-plus"
            [text]="'PERSON_GROUPS.DETAIL.ADD_PERSONS' | translate"
            [disabled]="isPersonGroupMembersLoading()"
            (click)="addPersons()">
          </ui-button>
        }
<!--        <ui-button-->
<!--          iconClass="ui-icon-globe"-->
<!--          [text]="'PERSON_GROUPS.DETAIL.SHARE_GROUP' | translate"-->
<!--          (click)="shareGroup()">-->
<!--        </ui-button>-->
      </div>
    </div>

    <div class="w-100 h-100" [class.persons-list]="membersViewState() === viewStates.HAS_CONTENT">
      @switch (membersViewState()) {
        @case (viewStates.HAS_CONTENT) {
          @for (person of members(); track person.personId) {
            <ui-person-tile
              [ngModel]="isPersonSelected(person.personId)"
              (ngModelChange)="updatePersonSelection(person.personId, $event)"
              [disabled]="isPersonRemoving(person.personId)"
              [showCheckbox]="canEditGroupMembers() && !isPersonRemoving(person.personId)"
              [label]="person.name || '-'"
              [imageUrl]="getImagePath(person)"
              [imageUrlFallback]="getImagePath(person, false)"
              [showConfirmationStatus]="true"
              [isConfirmed]="person.trainingStatus === personTrainingStatus.Trained"
              [isConfirming]="isPersonConfirming(person.personId)"
              (confirm)="openConfirmSavedPersonRecognitionDialog(person)"
            >
              <div class="flex-row gap-4">
                @if (canEditGroupMembers()) {
                  <ui-button
                    iconClass="ui-icon-edit"
                    type="secondary"
                    [rounded]="true"
                    [matTooltip]="'COMMON.EDIT' | translate"
                    matTooltipClass="sidebar-tooltip"
                    (clickAction)="openEditPersonDialog(person)"
                  ></ui-button>
                  <ui-button
                    iconClass="ui-icon-delete"
                    type="secondary"
                    [rounded]="true"
                    [matTooltip]="'PERSON_GROUPS.DETAIL.REMOVE_FROM_GROUP' | translate"
                    matTooltipClass="sidebar-tooltip"
                    [disabled]="isPersonRemoving(person.personId)"
                    (clickAction)="removeSingleMember(person.personId)"
                  ></ui-button>
                }
              </div>
            </ui-person-tile>
          }
        }
        @case (viewStates.INITIAL_EMPTY) {
          @if (isPersonGroupDetailsLoading() || isPersonGroupMembersLoading()) {
            <ui-preloader [color]="loaderColor.blue"></ui-preloader>
          } @else {
            <ui-no-data
              [imgSrc]="noData.noMembers.imgSrc"
              [title]="noData.noMembers.title | translate"
            ></ui-no-data>
          }
        }
      }
    </div>
    @if (canEditGroupMembers() && selectedPersonsCount() > 0) {
      <ui-selected-items-snackbar
        [counter]="selectedPersonsCount()"
        [selectedText]="'PERSONS.PERSONS_SELECTED'"
        (selectAll)="selectAllDisplayedPersons()"
        (clearAll)="clearSelectedPersons()"
      >
        <ui-button
          [text]="'COMMON.DELETE' | translate"
          type="secondary"
          [loading]="hasRemovingSelectedPersons()"
          [disabled]="hasRemovingSelectedPersons()"
          (clickAction)="removeSelectedMembers()"
        ></ui-button>
      </ui-selected-items-snackbar>
    }
  }
</div>
